(function () {
  var STORAGE_KEY = 'sv-free-throttle-popup-dismissed';
  var popup = document.querySelector('[data-promo-popup]');
  if (!popup) return;
  var panel = popup.querySelector('.sv-throttle-popup__panel');

  var alreadyDismissed = false;
  try {
    alreadyDismissed = sessionStorage.getItem(STORAGE_KEY) === 'true';
  } catch (e) {
    // sessionStorage unavailable (private browsing etc.) — just show it once this load
  }
  if (alreadyDismissed) return;

  function show() {
    popup.classList.add('sv-throttle-popup--open');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    // setTimeout instead of requestAnimationFrame: rAF is throttled/paused in
    // background tabs, which would leave the popup stuck at opacity 0 if it
    // opens while the tab isn't focused.
    setTimeout(function () {
      popup.classList.add('sv-throttle-popup--visible');
    }, 10);
  }

  function dismiss() {
    popup.classList.remove('sv-throttle-popup--visible');
    setTimeout(function () {
      popup.classList.remove('sv-throttle-popup--open');
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
    }, 200);
    try {
      sessionStorage.setItem(STORAGE_KEY, 'true');
    } catch (e) {
      // ignore
    }
  }

  popup.querySelectorAll('[data-promo-popup-close]').forEach(function (el) {
    el.addEventListener('click', dismiss);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('sv-throttle-popup--open')) dismiss();
  });

  setTimeout(show, 1800);
})();
